import {isUndefined} from '@esgi/ui';
import {isNull} from 'underscore';

export function getListValue(value: string | number | null | undefined) {
	return isNull(value) || isUndefined(value) ? '' : String(value);
}
